import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { insertNewLine } from '@/utils';
import { MovieWrapper, Movie, Title, Description, MarkdownStyle } from '@/components/Article/YoutubeSection.style';
import Section from '@/components/Section';
import Placeholder from '@/components/Placeholder';

/**
 * Youtube 動画表示用コンポーネント
 */
const YoutubeSection = ({ entryId, title, description, video }) => (
  <Section
    options={{
      outer: { style: { paddingBottom: 50, paddingTop: 50 } },
      inner: { locked: true },
      content: { locked: true },
    }}
    id={entryId}
  >
    <MovieWrapper>
      {!_.get(video, 'videoId') ? <Placeholder w="100%" h="100%" /> : (
        <Movie
          src={`https://www.youtube.com/embed/${video.videoId}`}
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          title={title}
        />
      )}
    </MovieWrapper>
    {/* title がない場合はトリツメする */}
    {title && (
      <Title>{title}</Title>
    )}
    {/* description がない場合はトリツメ */}
    {description && (
      <Description>
        {insertNewLine({ key: 'youtube-section', description, component: MarkdownStyle })}
      </Description>
    )}
  </Section>
);

YoutubeSection.defaultProps = {
  entryId: undefined,
  title: undefined,
  description: undefined,
  video: undefined,
};

YoutubeSection.propTypes = {
  entryId: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  video: PropTypes.shape(),
};

export default YoutubeSection;



// WEBPACK FOOTER //
// ./src/components/Article/YoutubeSection.js